import { createTheme } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles";

const defaultTheme = createTheme();

// colors
export const Colors = {
  green: "#3eb8aa",
  greenLight: "#3EB8AA",
  greenDark: "#11302D",
  black: "#11302D",
  blackLight: "#8CA2B7",
  blackDark: "#6B8299",
  darkSlate: "#415957",
  greySlate: "#6B8299",
  secondaryWhite: "#EEEEEE",
  white: "#fff",
  darkWhite: "#F9FAFA",
  lightWhite: "#E8EFF7",
  red: "#EC4949",
  blue: "#163D53",
  aliceblue: "#ECF0F3",
  loadingBlue: "#3eb8aa",
  Solitude: "#E3E6EC",
  PeurtoRico: "#3EB8AA",
  greyLight: "#11302D",
  lightYellow: "#ECB16D",
  lighterYellow: "#FFF8EF",
  pendingYellow: "#FFBB0E",
  alertYellow: "#FFCB7C",
  errorRed: "#f2d5d5",
  errorRedDark: "#ed4242",
  sliderBlue: "#4D92D5",
  swamp: "#748500",
  orange: "#ff870e",
};

// typography
const FONT_FAMILY = {
  oxygen: "Oxygen, sans-serif",
};

export const FONT_WEIGHT = {
  light: 300,
  regular: 400,
  medium: 500,
  semi: 600,
  bold: 700,
};

var theme = {
  FONT_WEIGHT,
  Colors,
  spacing: 8,
  palette: {
    primary: {
      main: Colors.green,
      light: Colors.greenLight,
      dark: Colors.greenDark,
      contrastText: Colors.white,
    },
    secondary: {
      main: Colors.black,
      light: Colors.blackLight,
      dark: Colors.blackDark,
      borderlight: alpha(Colors.black, 0.1),
    },
  },

  typography: {
    fontFamily: FONT_FAMILY.oxygen,
    // color: Colors.black,
    h1: {
      fontSize: "3.5rem", //.5rem = 56px
      fontWeight: FONT_WEIGHT.bold,
      lineHeight: "3.9rem", //3.9rem = 63px
      [defaultTheme.breakpoints.down("md")]: {
        fontSize: "2rem", // 32px
        lineHeight: "2.375rem", // 38px
      },
    },
    h2: {
      fontSize: "2rem", //2rem = 32px
      fontWeight: FONT_WEIGHT.bold,
      lineHeight: "2.25rem", //2.25 = 36px
      [defaultTheme.breakpoints.down("md")]: {
        fontSize: "1.5rem", // 24px
        lineHeight: "2.25rem", // 36px
      },
    },
    h3: {
      fontSize: "1.5rem", //1.5rem = 24px
      fontWeight: FONT_WEIGHT.bold,
      lineHeight: "1.68rem", //1.68rem = 27px
      [defaultTheme.breakpoints.down("md")]: {
        fontSize: "1rem", // 24px
        lineHeight: "1.5rem", // 36px
      },
    },
    h4: {
      fontSize: "1.25rem", //1.25rem = 20px
      fontWeight: FONT_WEIGHT.bold,
      lineHeight: "1.87rem", //1.87rem = 30px
    },
    h5: {
      fontSize: "1.125rem", //1.125rem = 18px
      fontWeight: FONT_WEIGHT.bold,
      lineHeight: "1.56rem", //1.56rem = 25px
    },
    h6: {
      fontSize: "1rem", //1rem = 16px
      fontWeight: FONT_WEIGHT.bold,
      lineHeight: "1.5rem", //1.5rem = 24px
    },
    body1: {
      fontSize: "1rem", //1rem = 16px
      fontWeight: FONT_WEIGHT.regular,
      lineHeight: "1.5rem", //1.5rem = 25px
      color: alpha("#11302D", 0.8),
    },
    body2: {
      fontSize: "0.875rem", //0.875rem = 14px
      fontWeight: FONT_WEIGHT.regular,
      lineHeight: "1.5rem", //1.5rem = 25px
    },
    subtitle1: {
      fontSize: "0.75rem", //0.75rem = 12px
      fontWeight: FONT_WEIGHT.bold,
      lineHeight: "0.938rem", //0.938rem = 15px
    },
  },
  //shadows: "none", //remove shadows from whole mui

  overrides: {
    MuiTypography: {
      colorTextSecondary: {
        color: Colors.white,
      },
    },
    MuiContainer: {
      maxWidthLg: {
        [defaultTheme.breakpoints.up("lg")]: {
          //above 1280px
          maxWidth: "1193px",
        },
      },
      fixed: {},
    },
    MuiAppBar: {
      root: {
        backgroundColor: Colors.white,
        boxShadow: "none",
      },
    },
    MuiToolbar: {
      gutters: {
        paddingLeft: "0",
        paddingRight: "0",
      },
    },
    MuiInputLabel: {
      root: {
        fontFamily: FONT_FAMILY.oxygen,
      },
    },
    MuiChip: {
      root: {
        paddingLeft: "5px",
      },
      label: {
        paddingLeft: "5px",
      },
    },
    MuiSelect: {
      root: {
        display: "flex",
        alignItems: "center",
      },
      select: {
        "&:focus": {
          backgroundColor: "transparent",
        },
      },
    },
    MuiButton: {
      root: {
        // Name of the rule
        borderRadius: "78px",
        "&.MuiButton-medium": {
          minWidth: "144px",
          padding: "10px 16px",
        },
      },
      label: {
        fontSize: "1rem",
        fontWeight: FONT_WEIGHT.bold,
        textTransform: "capitalize",
      },
      contained: {
        boxShadow: "none",
        backgroundColor: Colors.aliceblue,
        color: Colors.blackDark,
      },
      containedSizeLarge: {
        padding: "10px 22px",
        minWidth: "180px",
      },

      containedSizeSmall: {
        padding: "6px 15px",
        boxShadow: "none",
      },
      outlinedSizeSmall: {
        padding: "5px 15px",
        boxShadow: "none",
      },
      outlinedSecondary: {
        border: `1px solid ${Colors.black}`,
        "&:hover": {
          color: Colors.black,
        },
      },
      outlinedPrimary: {
        border: `1px solid ${Colors.green}`,
        "&:hover": {
          color: Colors.green,
        },
      },
    },
    MuiPaper: {
      root: {
        // backgroundColor:'transparent',
      },
    },
    MuiPopover: {
      paper: {
        borderRadius: "8px",
        backgroundColor: Colors.white,
        overflowX: "visible",
        overflowY: "visible",
      },
    },
    MuiInputBase: {
      root: {
        color: Colors.black,
      },
      input: {
        "&::placeholder": {
          color: Colors.blackDark,
          opacity: "1",
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        "&:hover $notchedOutline": {
          borderColor: "#E3E6EC",
        },
        "&.Mui-error": {
          borderColor: "#E3E6EC",
        },
      },
      inputMarginDense: {
        paddingTop: "15px",
        paddingBottom: "15px",
        paddingLeft: "15px",
        paddingRight: "15px",
      },
      notchedOutline: {
        borderColor: "#E3E6EC",
      },
    },
    MuiFormHelperText: {
      root: {
        "&.Mui-error": {
          color: "#CD2D27",
        },
      },
      contained: {
        marginLeft: "0",
        marginRight: "0",
      },
    },
    MuiPaginationItem: {
      outlinedPrimary: {
        border: "1px solid rgba(17,48,45,0.1)",
        color: Colors.blackDark,
        "&$selected": {
          backgroundColor: Colors.green,
          color: Colors.white,
          "&:hover": {
            backgroundColor: Colors.green,
          },
        },
      },
      rounded: {
        borderRadius: "8px",
      },
    },
    MuiLinearProgress: {
      root: {
        height: 8,
        borderRadius: 5,
      },
      bar: {
        borderRadius: 5,
      },
    },
    MuiTableRow: {
      root: {
        display: "inline-table",
        marginBottom: "2px",
        width: "100%",
        boxShadow: "none",
        backgroundColor: alpha("#fff", 0.8),
        // border: `1px solid ${Colors.lightWhite}`,
      },
    },
    MuiTableCell: {
      root: {
        color: alpha(Colors.black, 0.8),
        fontSize: "1.25rem",
        borderBottom: "0px",
      },
      head: {
        color: alpha(Colors.black, 0.8),
        fontWeight: FONT_WEIGHT.bold,
        padding: "28px 16px",
        "&:first-child": {
          width: "155px",
        },
      },
      body: {
        fontSize: "1.25rem",
        color: alpha(Colors.black, 0.8),
        "&:first-child": {
          color: alpha(Colors.black, 1),
          width: "155px",
        },
        "&:nth-child(2)": {
          width: "125px",
        },
        "&:nth-child(3)": {
          fontWeight: FONT_WEIGHT.bold,
          color: alpha(Colors.black, 1),
          width: "120px",
        },
        "&:nth-child(4)": {
          fontWeight: FONT_WEIGHT.bold,
          width: "100px",
        },
      },
    },

    MuiTab: {
      root: {
        border: `1px solid ${alpha(Colors.black, 0.1)}`,
        borderRadius: "36px",
        padding: "0 24px",

        [defaultTheme.breakpoints.down("xs")]: {
          minWidth: "90px",
        },
      },

      textColorSecondary: {
        color: Colors.greySlate,
        fontSize: "1rem",
        fontWeight: FONT_WEIGHT.bold,
        minHeight: "48px",
        textTransform: "inherit",
        [defaultTheme.breakpoints.down("xs")]: {
          minHeight: "40px",
        },
        "&.Mui-selected": {
          backgroundColor: Colors.black,
          color: Colors.white,
        },
      },
    },
    MuiTabs: {
      indicator: {
        display: "none",
      },
    },

    //stepper
    MuiStepper: {
      root: {
        padding: "0px",
      },
    },
    MuiStepLabel: {
      label: {
        color: Colors.darkSlate,
        fontSize: "12px",
        "&.MuiStepLabel-alternativeLabel": {
          marginTop: "8px",
        },
        "&$active": {
          color: Colors.green,
        },
      },
    },

    MuiStepIcon: {
      root: {
        width: "32px",
        height: "32px",
        border: `1px solid ${alpha(Colors.black, 0.1)}`,
        borderRadius: "16px",
        color: "transparent",
        "&$active": {
          border: `1px solid transparent`,
        },
      },
      text: {
        fill: Colors.greySlate,
      },
      active: {
        "& .MuiStepIcon-text": {
          fill: Colors.white,
        },
      },
    },
    MuiStepButton: {
      root: {
        width: "100px",
        padding: "0px",
        marginTop: "10px",
        marginRight: "-48px",
        marginLeft: "-32px",
      },
      touchRipple: {
        display: "none",
      },
    },
    MuiStep: {
      alternativeLabel: {
        flex: "none",
      },
    },

    // Dialog
    MuiDialog: {
      paperScrollPaper: {
        [defaultTheme.breakpoints.down("sm")]: {
          maxHeight: "500px",
          overflow: "auto",
        },
      },
      paper: {
        [defaultTheme.breakpoints.down("sm")]: {
          margin: "0px",
        },
      },
      paperWidthMd: {
        width: "660px",
        borderRadius: "16px",
        [defaultTheme.breakpoints.down("sm")]: {
          minWidth: "100%",
          overflowY: "inherit",
          borderRadius: "24px 24px 0px 0px",
        },
      },
      paperWidthSm: {
        width: "509px",
        margin: "0px",
        borderRadius: "16px",
        [defaultTheme.breakpoints.down("sm")]: {
          minWidth: "100%",
          overflowY: "inherit",
          borderRadius: "24px 24px 0px 0px",
        },
      },
      scrollPaper: {
        [defaultTheme.breakpoints.down("sm")]: {
          alignItems: "flex-end",
        },
      },
    },
    MuiFormControl: {
      root: {
        "&.icondropdown": {
          position: "absolute",
          left: "0",
        },
      },
    },
    //radio button

    MuiFormControlLabel: {
      label: {
        color: Colors.black,
      },
    },
    // button group
    MuiButtonGroup: {
      groupedOutlinedHorizontal: {
        border: `1px solid ${alpha(Colors.black, 0.1)}`,
        "&:not(:first-child)": {
          borderLeftColor: "transparent",
        },
      },
    },
    // accordion
    MuiAccordion: {
      root: {
        position: "unset",
        marginBottom: "12px",
        boxShadow: "0px 7px 41px rgba(17, 48, 45, 0.04)",
        border: `1px solid ${alpha(Colors.black, 0.1)}`,
        marginRight: "16px !important",
      },
    },
    MuiAccordionSummary: {
      root: {
        minHeight: "80px",
        [defaultTheme.breakpoints.down("sm")]: {
          minHeight: "100%",
        },
      },
      expandIcon: {
        marginRight: 0,
        [defaultTheme.breakpoints.down("sm")]: {
          marginRight: "-17px",
        },
      },
    },
    // menu paper select component
    MuiMenu: {
      paper: {},
      list: {
        overflowY: "scroll",
        "&::-webkit-scrollbar": {
          width: "4px",
        },
        "&::-webkit-scrollbar-track": {},
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "10px",
          background: "#ECF0F3 ",
        },
      },
    },
    MuiListItem: {
      root: {
        "&.Mui-selected": {
          backgroundColor: "#22dbb547",
          "&:hover": {
            backgroundColor: "#22dbb547",
          },
        },
      },
      button: {
        "&:active": {
          backgroundColor: "#22dbb547",
        },
        "&:hover": {
          backgroundColor: "#22dbb547",
          color: Colors.black,
        },
      },
    },
    // switch
    MuiSwitch: {
      root: {
        width: 44,
        height: 24,
        padding: 0,
      },
      switchBase: {
        padding: 1,
        "&$checked": {
          color: Colors.white,
        },
      },

      track: {
        borderRadius: "22px",
        backgroundColor: Colors.aliceblue,
        opacity: 1,
        "$checked$checked + &": {
          opacity: 1,
          backgroundColor: Colors.black,
        },
      },
      colorSecondary: {
        "&$checked": {
          // Controls checked color for the thumb
          color: Colors.white,
        },
      },
    },
  },
} as object;

export default createTheme(theme);
